<template>
  <div class="page-today-performance">
    <div class="search-form">
      <el-form
        inline
        ref="searchForm"
        :model="searchData"
      >
        <el-form-item
          label="产品类型"
          prop="prdType"
        >
          <el-select
            v-model="searchData.prdType"
            clearable
          >
            <el-option
              v-for="item in dictList"
              :key="item.dictValue"
              :label="item.dictName"
              :value="item.dictValue"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="交易日期"
          style="margin-right: 13px;"
          prop="startDate"
        >
          <el-date-picker
            v-model="searchData.startDate"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            type="date"
            clearable
            placeholder="开始日期"
            :picker-options="$_yh_before(searchData.endDate)"
          ></el-date-picker>
        </el-form-item>
        <el-form-item
          label="至"
          prop="endDate"
        >
          <el-date-picker
            v-model="searchData.endDate"
            clearable
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="结束日期"
            :picker-options="$_yh_after(searchData.startDate)"
          ></el-date-picker>
        </el-form-item>
      </el-form>
    </div>
    <section class='flex-between'>
      <div>
        <el-button
          type="primary"
          size="small"
          @click='onSearchClick'
        >查询</el-button>
        <el-button
          size="small"
          @click='onResetClick'
        >清空查询条件</el-button>
      </div>
    </section>
    <p style="padding-top: 20px;">今日成交额(元):{{`${amount}`|formatCurrency}}</p>
    <el-table
      border
      :data="tableData"
    >
      <template slot="empty">{{emptyText}}</template>
      <el-table-column
        v-for="col in tableLabel"
        :key="col.prop"
        :label="col.label"
        :prop="col.prop"
        :formatter="formatter"
        :min-width="col.width"
      ></el-table-column>
    </el-table>
    <yh-pagination
      :page.sync="currentPage"
      :total="sumCount"
    />
  </div>
</template>
<script>
import { getPagingData } from '@/mixins';
import mixin from '../mixin';

export default {
  name: 'TodayPerformance',
  mixins: [getPagingData, mixin],
  data() {
    return {
      amount: 0,
      dictList: [],
      emptyText: this.$LS.empty,
      tableLabel: [{
        label: '产品类型',
        prop: 'prdTypeRes',
      }, {
        label: '产品名称',
        prop: 'prdName',
        width: 200,
      }, {
        label: '产品代码',
        prop: 'prdCode',
        width: 200,
      }, {
        label: '交易金额(元)',
        prop: 'transMoney',
        width: 200,
      }, {
        label: '网点名称',
        prop: 'orgnName',
        width: 200,
      }, {
        label: '客户经理姓名',
        prop: 'workName',
        width: 130,
      }, {
        label: '交易时间',
        prop: 'transTime',
        width: 200,
      }],
      currentPage: 1,
      sumCount: 0,
      tableData: [],
      searchParam: {
        startDate: '',
        endDate: '',
        prdType: '',
        workNo: this.$store.getters.workNo,
      },
      searchData: {
        startDate: '',
        endDate: '',
        prdType: '',
        workNo: this.$store.getters.workNo,
      },
    };
  },

  computed: {
    searchForm() {
      return this.$refs.searchForm;
    },
  },

  watch: {
    currentPage: {
      immediate: false,
      handler() {
        this.getTableData();
      },
    },
  },

  activated() {
    if (this.$route.query.today) {
      const date = this.formatDate(Date.now());
      this.searchData.startDate = date;
      this.searchData.endDate = date;
      this.searchParam = {
        ...this.searchData,
      };
      if (this.currentPage === 1) {
        this.getTableData();
      } else {
        this.currentPage = 1;
      }
    }
    this.getTradeAmount();
  },

  methods: {
    getTradeAmount() {
      return this.$_post(this.$API.getTradeAmount, {
        data: {
          workNo: this.$store.getters.workNo,
        },
      }).then((res) => {
        this.amount = res.data.info;
      });
    },
    onResetClick() {
      this.searchForm.resetFields();
    },
    formatter(row, col, cellValue) {
      if (col.property === 'transTime') {
        return this.formatTime(cellValue);
      }
      if (col.property === 'transMoney') {
        return this.formatCurrency(cellValue);
      }
      return cellValue || '-';
    },
    onSearchClick() {
      this.searchParam = {
        ...this.searchData,
      };
      if (this.currentPage === 1) {
        this.getTableData();
      } else {
        this.currentPage = 1;
      }
    },
    getTableData() {
      this.getPagingData(this.$API.listTask);
    },
  },
};
</script>
